module.exports = __webpack_public_path__ + "img/engagementring@2x.a7d9f3b.png";